module.exports = __webpack_public_path__ + "img/益视说明书_23.d9018d3a.png";